import type { ValidationConfig } from '../../../core/dataProcessor/types';

export const lineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', array: true, required: true },
    { field: 'z', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'line-multi-y-z-conflict',
      validator: (data, layer) => {
        const { encoding } = layer;
        return !(encoding?.z && Array.isArray(encoding?.y) && encoding.y.length > 1);
      },
      message: 'Multiple Y axes with Z dimension is not supported',
      suggestion: 'Use single Y field when Z dimension is present',
      severity: 'warning'
    }
  ]
};
